/*
  Accessibility Fix: JDGM Buttons Tab Index
  -----------------------------------------
  Date: 11-18-2025

  Purpose:
  The Judgeme (JDGM) app buttons (write review link and general buttons) were 
  not reachable via keyboard tabbing. This script ensures they can be focused 
  with the keyboard by adding `tabindex="0"`.

  How it works:
  1. `addTabIndexToJDGMElements()` adds `tabindex="0"` to JDGM elements that 
     don’t already have it.
  2. A MutationObserver watches for dynamically added elements and applies the 
     tabindex automatically.
  3. Also runs once on DOMContentLoaded to handle elements present on initial load.

  Selectors targeted:
  - `.jdgm-write-rev-link`
  - `.jdgm-btn`
*/



function addTabIndexToJDGMElements() {
  const selectors = ['.jdgm-write-rev-link', '.jdgm-btn'];
  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }
    });
  });
}

// Set up a MutationObserver to handle dynamically added elements
const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    if (mutation.addedNodes.length > 0) {
      addTabIndexToJDGMElements();
    }
  });
});

// Start observing the body for added elements
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also run once after DOM is initially ready
document.addEventListener('DOMContentLoaded', addTabIndexToJDGMElements);
